import React from 'react';
import PropTypes from 'prop-types';
import Swiper from 'react-id-swiper';

export default class SwiperSlide extends React.Component {
  constructor(props) {
    super(props)

    this.state = { 
      ...props.config,
    }
  }
  
  
  render() {
    const {children, config, ...rest } = this.props;
    const params = { 
      pagination: {
        el: '.SwiperSlide-pagination.mdm-Swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      navigation: {
        prevEl: '.SwiperSlide-buttonPrev.mdn-Swiper-button-prev.mdn-Icon-esquerda.mdn-Icon--lg',
        nextEl: '.SwiperSlide-buttonNext.mdn-Swiper-button-next.mdn-Icon-direita.mdn-Icon--lg'
      },
      spaceBetween: config && config.spaceBetween || 30,
      slidesPerView: config && config.slidesPerView || 1
    }
    const props = clearProps(this.props);

    return (

    <Swiper
      {...props}
      pagination={typeof config.pagination === "boolean" && !config.pagination ? "" : params.pagination}
      navigation={typeof config.navigation === "boolean" && !config.navigation ? "" : params.navigation}
      spaceBetween={params.spaceBetween}
      slidesPerView={params.slidesPerView}
    >
      {children}
    </Swiper>
    
    )
  }
}

SwiperSlide.propTypes = {
  params : PropTypes.object,
  children : PropTypes.node,
  config : PropTypes.object
}